<script>
import { required } from "vuelidate/lib/validators";

import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { iot_device_type } from "@/helpers/global.variable";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Device Model",
  },
  emits: ["submitted", "cancelSubmit"],
  props: {
    currentProps: Object,
  },
  data() {
    return {
      deviceTypes: iot_device_type,
      device_model_form: {
        device_type: null,
        name: null,
      },
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
    };
  },
  components: {
    Multiselect,
  },
  validations: {
    device_model_form: {
      device_type: {
        required,
      },
      name: {
        required,
      },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to handle set value
    setValue() {
      if (this.currentProps.isEdit) {
        this.device_model_form.device_type =
          this.currentProps.deviceModel.device_type;
        this.device_model_form.name = this.currentProps.deviceModel.name;
      }
    },
    // Method is used to add and update device model data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.currentProps.isEdit == false) {
          UserService.addDeviecModel(this.device_model_form)
            .then((response) => {
              this.isBtnLoading = false;
              this.submitted = false;
              this.$emit("submitted", { data: response });
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.editDeviecModelData(
            this.currentProps.deviceModelId,
            this.device_model_form
          )
            .then((response) => {
              this.$emit("submitted", { data: response, isEdit: true });
              this.isBtnLoading = false;
              this.submitted = false;
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Update" : "Add New" }} Device Model</h4>
      <hr />
    </div>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="name">Name <span class="text-danger">*</span></label>
            <b-form-input
              id="name"
              type="text"
              v-model="device_model_form.name"
              autocomplete="off"
              :class="{
                'is-invalid': submitted && $v.device_model_form.name.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.device_model_form.name.required"
                >Name is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="device_type"
              >Device Type <span class="text-danger">*</span></label
            >
            <multiselect
              v-model="device_model_form.device_type"
              :options="deviceTypes"
              :show-labels="false"
              placeholder=""
              label="text"
              track-by="value"
              :class="{
                'is-invalid':
                  submitted && $v.device_model_form.device_type.$error,
              }"
            ></multiselect>

            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.device_model_form.device_type.required"
                >Device type is required.</span
              >
            </div>
          </div>
        </div>
        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              {{ index }}: {{ error[0] }}
            </li>
          </ul>
        </b-alert>
        <hr />
        <div class="col-sm-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="$emit('cancelSubmit')"
            >Cancel</b-button
          >

          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="onSubmit"
          >
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
